export function isNumeric(str) {
  if (typeof str != "string") return false; // we only process strings!
  return (
    !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str))
  ); // ...and ensure strings of whitespace fail
}

export function capitalizeFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function convertSortDir(string) {
  return string === "ascend" ? "ASC" : "DESC";
}

export function makeRandomId(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function tallyArrayByProp(arr, attr) {
  const result = {};
  arr.forEach((arre) => {
    const key = arre.uid;
    if (key in result) {
      result[key][attr] = result[key][attr] + arre[attr];
    } else {
      result[key] = { ...arre };
    }
  });
  // Convert object into array
  const changingItems = [];
  for (let res in result) {
    changingItems.push(result[res]);
  }
  return changingItems;
}

export function sumPriceAndAmount(basket) {
  // Calculate for total items and price
  let totalPrice = 0;
  let totalItems = 0;
  for (let i = 0; i < basket.length; i++) {
    totalPrice += parseFloat(basket[i].price) * basket[i].amount;
    totalItems += basket[i].amount;
  }
  return { totalPrice, totalItems };
}
